module.exports = __webpack_public_path__ + "media/images/athletes/1430-cbe38c991f88d1200726eef831ce4613.png";